
import Layout from '@/pages/layout'
export const zzshRoutes = [
	{
		path:'/shyk',
		name:"三会一课",
		component: () => import('@/pages/zzsh/shyk'),
		meta:{
			isMenu:true,
			requiresAuth:[1,2,3],
			activeMenu:'/zzsh'
		}
	},
	{
		path:"/zzhd_add",
		name:"新增三会一课",
		component: () => import('@/pages/zzsh/shyk/zzhd_add.vue'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3],
			activeMenu:'/zzsh'
		}
	},
	{
		path:"/zzhd_detaill",
		name:"三会一课详情",
		component: () => import('@/pages/zzsh/shyk/zzhd_detaill.vue'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3],
			activeMenu:'/zzsh'
		}
	},
	{
		path:'/txthjl',
		name:"谈心谈话记录",
		component: () => import('@/pages/zzsh/txthjl'),
		meta:{
			isMenu:true,
			requiresAuth:[1,2,3],
			activeMenu:'/zzsh'
		}
	},
	{
		path:'/txth_detail',
		name:"谈心谈话详情",
		component: () => import('@/pages/zzsh/txthjl/txth_detail'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3],
			activeMenu:'/zzsh'
		}
	},
	{
		path:'/txth_add',
		name:"新增谈心谈话",
		component: () => import('@/pages/zzsh/txthjl/txth_add'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3],
			activeMenu:'/zzsh'	
		}
	},
	{
		path:'/mzpyjl',
		name:"民主评议记录",
		component: () => import('@/pages/zzsh/mzpyjl'),
		meta:{
			isMenu:true,
			requiresAuth:[1,2,3],
			activeMenu:'/zzsh'	
		}
	},
	{
		path:'/mzpyjl_detail',
		name:"民主评议记录详情",
		component: () => import('@/pages/zzsh/mzpyjl/detail'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3],
			activeMenu:'/zzsh'			
		}
	},
	{
		path:"/sxhb",
		name:"思想汇报",
		component: () => import('@/pages/zzsh/sxhb'),
		meta:{
			isMenu:true,
			requiresAuth:[1,2,3],
			activeMenu:'/zzsh'		
		}
	},
	{
		path:"/sxhbdetail",
		name:"思想汇报详情",
		component: () => import('@/pages/zzsh/sxhb/detail'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3],
			activeMenu:'/zzsh'			
		}
	}
]

// 党员教育
export const dyjyRoutes = [
	// {
	// 	name:"年度学习计划",
	// 	path:"/ndjh",
	// 	component: {render(c){return c('router-view')}},
	// 	meta:{
	// 		isMenu:true,
	// 		requiresAuth:[1,2]
	// 	},
	// 	children:[
	// 		{
	// 			name:"制定计划",
	// 			path:"/zdjh",
	// 			component: () => import('@/pages/dyjy/ndxxjh/zdjh'),
	// 			meta:{
	// 				isMenu:true,
	// 				requiresAuth:[1,2,3]
	// 			},
	// 		},
	// 		{
	// 			name:"督办提醒",
	// 			path:"/dbtx",
	// 			component: () => import('@/pages/dyjy/ndxxjh/dbtx'),
	// 			meta:{
	// 				isMenu:true,
	// 				requiresAuth:[1,2]
	// 			},
	// 		}
	// 	]
	// },
	// {
	// 	path:"/zdjh",
	// 	name:"年度学习计划",
	// 	component: () => import('@/pages/dyjy/ndxxjh/zdjh'),
	// 	meta:{
	// 		isMenu:true,
	// 		requiresAuth:[3],
	// 		activeMenu:'/zzsh'
	// 	}
	// },
	// {
	// 	name:"计划资源",
	// 	path:"/resource",
	// 	component: () => import('@/pages/dyjy/ndxxjh/zdjh/detail'),
	// 	meta:{
	// 		isMenu:false,
	// 		requiresAuth:[1,2,3],
	// 		activeMenu:'/zzsh'
	// 	}
	// },
	// {
	// 	name:"新增计划资源",
	// 	path:"/addResource",
	// 	component: () => import('@/pages/dyjy/ndxxjh/zdjh/addResource'),
	// 	meta:{
	// 		isMenu:false,
	// 		requiresAuth:[1,2,3],
	// 		activeMenu:'/zzsh'
	// 	}
	// },
	{
		name:"个人学习任务",
		path:"/grxxjl",
		component: () => import('@/pages/dyjy/grxxjl'),
		meta:{
			isMenu:true,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:"/grxx_detaill",
		name:"个人学习任务详情",
		component: () => import('@/pages/dyjy/grxxjl/grxx_detaill'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:"/grxx_add",
		name:"新个人学习任务增",
		component: () => import('@/pages/dyjy/grxxjl/grxx_add'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
	{
		name:"资源管理",
		path:"/ztpx",
		component: {render(c){return c('router-view')}},
		meta:{
			isMenu:true,
			requiresAuth:[1,2,3]
		},
		children:[
			{
				name:"自建专题",
				path:"/ztpx",
				component: () => import('@/pages/dyjy/ztpx/ztzy'),
				meta:{
					isMenu:true,
					requiresAuth:[1,2,3]
				},
			},
			{
				path:"/add_zt",
				name:"新建专题",
				component: () => import('@/pages/dyjy/ztpx/ztzy/components/add_zt'),
				meta:{
					isMenu:false,
					requiresAuth:[1,2,3]
				}
			},
			{
				path:"/ztlist",
				name:"专题内容",
				component: () => import('@/pages/dyjy/ztpx/ztzy/ztlist.vue'),
				meta:{
					isMenu:false,
					requiresAuth:[1,2,3]
				}
			},
			{
				path:"/add_nr",
				name:"新建专题内容",
				component: () => import('@/pages/dyjy/ztpx/ztzy/components/add_nr'),
				meta:{
					isMenu:false,
					requiresAuth:[1,2,3]
				}
			},
			// {
			// 	name:"随堂测试",
			// 	path:"/stcs",
			// 	component: () => import('@/pages/dyjy/ztpx/stcs'),
			// 	meta:{
			// 		isMenu:true,
			// 		requiresAuth:[1,2,3]
			// 	},
			// },
			{
				path:'/zjzt_detail',
				name:"自建专题详情",
				component:() => import('@/pages/dyjy/ztpx/ztzy/zjzt_detail.vue'),
				meta:{
					isMenu:false,
					requiresAuth:[1,2,3]
				}
			},
		]
	},
	{
		name:"在线考试",
		path:"/zxks",
		component: {render(c){return c('router-view')}},
		meta:{
			isMenu:true,
			requiresAuth:[1,2,3]
		},
		children:[
			{
				name:"试卷管理",
				path:"/sjgl",
				component: () => import('@/pages/dyjy/zxks/sjgl'),
				meta:{
					isMenu:true,
					requiresAuth:[1,2,3]
				},
			},
			{
				path:"/add_sj",
				name:"新增试卷",
				component: () => import('@/pages/dyjy/zxks/sjgl/components/add_sj'),
				meta:{
					isMenu:false,
					requiresAuth:[1,2,3]
				},
			},
			{
				path:"/add_sjzj",
				name:"新增随即组卷",
				component: () => import('@/pages/dyjy/zxks/sjgl/components/add_sjzj'),
				meta:{
					isMenu:false,
					requiresAuth:[1,2,3]
				},
			},
			{
				name:"试题管理",
				path:"/stgl",
				component: () => import('@/pages/dyjy/zxks/stgl'),
				meta:{
					isMenu:true,
					requiresAuth:[1,2,3]
				},
			},
			{
				path:"/add_st",
				name:"新增试题",
				component: () => import('@/pages/dyjy/zxks/stgl/components/add_st'),
				meta:{
					isMenu:false,
					requiresAuth:[1,2,3]
				},
			},
			{
				path:"/stlist",
				name:"试题题干列表",
				component: () => import('@/pages/dyjy/zxks/stgl/stlist'),
				meta:{
					isMenu:false,
					requiresAuth:[1,2,3]
				},
			},
			{
				path:"/add_tg",
				name:"新增题干",
				component: () => import('@/pages/dyjy/zxks/stgl/components/add_tg'),
				meta:{
					isMenu:false,
					requiresAuth:[1,2,3]
				},
			},
			{
				name:"考试记录",
				path:"/ksjl",
				component: () => import('@/pages/dyjy/zxks/zxks'),
				meta:{
					isMenu:true,
					requiresAuth:[1,2,3]
				},
			},
			{
				path:"/zxks_detail",
				name:'在线考试详情',
				component: () => import('@/pages/dyjy/zxks/zxks/zxks_detail'),
				meta:{
					isMenu:false,
					requiresAuth:[1,2,3]
				},
			},
			{
				path:"/add_ks",
				name:'添加在线考试',
				component: () => import('@/pages/dyjy/zxks/zxks/components/add_ks'),
				meta:{
					isMenu:false,
					requiresAuth:[1,2,3]
				},
			},
		]
	},
]

// 党务工作
export const dwgzRoutes = [
	{
		path:'/dzz',
		name:"党组织管理",
		component:() => import('@/pages/dwgl/dzz'),
		meta:{
			isMenu:true,
			requiresAuth:[1,2]
		}
	},
	{
		name:"党员管理",
		path:"/dyxxgl",
		component: {render(c){return c('router-view')}},
		meta:{
			isMenu:true,
			requiresAuth:[1,2,3]
		},
		children:[
			{
				name:"党员信息",
				path:"/dyxxgl",
				component: () => import('@/pages/dwgl/dyxxgl'),
				meta:{
					isMenu:true,
					requiresAuth:[1,2,3]
				},
			},
			{
				path:"/dyxx_add",
				name:"新增党员",
				component: () => import('@/pages/dwgl/dyxxgl/dyxx_add'),
				meta:{
					isMenu:false,
					requiresAuth:[1,2,3]
				}
			},
			{
				path:"/dyxx_detail",
				name:"党员信息详情",
				component: () => import('@/pages/dwgl/dyxxgl/dyxx_detail.vue'),
				meta:{
					isMenu:false,
					requiresAuth:[1,2,3]
				}
			},
			{
				name:"领导班子",
				path:"/ldbz",
				component: () => import('@/pages/dwgl/ldbz'),
				meta:{
					isMenu:true,
					requiresAuth:[1,2,3]
				},
			},
			{
				name:"发展党员",
				path:"/fzdy_charge",
				component: () => import('@/pages/dwgl/fzdy_charge'),
				meta:{
					isMenu:true,
					requiresAuth:[1,2,3]
				},
			},
			{
				path:"/fzdy_detail",
				name:"发展党员详情",
				component: () => import('@/pages/dwgl/fzdy_charge/fzdy_detail'),
				meta:{
					isMenu:false,
					requiresAuth:[1,2,3]
				}
			},
			{
				name:"关系转接",
				path:"/gxzy",
				component: () => import('@/pages/dwgl/gxzy'),
				meta:{
					isMenu:true,
					requiresAuth:[1,2,3]
				},
			},
			{
				path:"/gxzy_add",
				name:"新增关系转移",
				component: () => import('@/pages/dwgl/gxzy/gxzy_add'),
				meta:{
					isMenu:false,
					requiresAuth:[1,2,3]
				}
			},
			{
				path:"/gxzy_detail",
				name:"关系转移详情",
				component: () => import('@/pages/dwgl/gxzy/gxzy_detail'),
				meta:{
					isMenu:false,
					requiresAuth:[1,2,3]
				}
			},
		]
	},
	{
		path:"/dzz_detail",
		name:"党组织详情",
		component: () => import('@/pages/dwgl/dzz/dzz_detail.vue'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2]
		}
	},
	{
		path:'/dftj',
		name:"党费统计",
		component:() => import('@/pages/dwgl/dftj'),
		meta:{
			isMenu:true,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:'/jfgl',
		name:"经费管理",
		component:() => import('@/pages/dwgl/jfgl'),
		meta:{
			isMenu:true,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:'/dwgk',
		name:"党务公开",
		component:() => import('@/pages/dwgl/dwgk'),
		meta:{
			isMenu:true,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:"/dwgk_detail",
		name:"党务公开详情",
		component: () => import('@/pages/dwgl/dwgk/detail'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:"/dwgk_add",
		name:"新增党务公开",
		component: () => import('@/pages/dwgl/dwgk/add'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:'/rcbg_fbtz',
		name:"通知公告",
		component:() => import('@/pages/dwgl/rcbg_fbtz'),
		meta:{
			isMenu:true,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:"/add_tz",
		name:"发布通知公告",
		component: () => import('@/pages/dwgl/rcbg_fbtz/add_tz'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:"/fbtz_detail",
		name:"通知公告详情",
		component: () => import('@/pages/dwgl/rcbg_fbtz/fbtz_detail'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:'/rcbg_gzhb',
		name:"工作汇报",
		component:() => import('@/pages/dwgl/rcbg_gzhb'),
		meta:{
			isMenu:true,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:"/add_hb",
		name:"新增工作汇报",
		component: () => import('@/pages/dwgl/rcbg_gzhb/add_hb'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:"/gzhb_detail",
		name:"工作汇报详情",
		component: () => import('@/pages/dwgl/rcbg_gzhb/gzhb_detail'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:'/nzkh',
		name:"年终考核",
		component: {render(c){return c('router-view')}},
		meta:{
			isMenu:true,
			requiresAuth:[1,2,3]
		},
		children:[
			{
				name:"支部标准化建设",
				path:"/bzhjs",
				component: () => import('@/pages/dwgl/nzkh/bzhjs'),
				meta:{
					isMenu:true,
					requiresAuth:[1,2]
				},
			},
			{
				path:"/pfxz",
				name:"评分细则",
				component: () => import('@/pages/dwgl/nzkh/bzhjs/pfxz'),
				meta:{
					isMenu:false,
					requiresAuth:[1,2,3]
				}
			},
			{
				name:"优秀共产党员",
				path:"/yxgcdy",
				component: () => import('@/pages/dwgl/nzkh/yxgcdy'),
				meta:{
					isMenu:true,
					requiresAuth:[1,2,3]
				},
			},
			{
				path:"/pfxz1",
				name:"评分细则",
				component: () => import('@/pages/dwgl/nzkh/yxgcdy/pfxz'),
				meta:{
					isMenu:false,
					requiresAuth:[1,2,3]
				}
			},
			{
				name:"优秀党务工作者",
				path:"/yxdwgzz",
				component: () => import('@/pages/dwgl/nzkh/yxdwgzz'),
				meta:{
					isMenu:true,
					requiresAuth:[1,2,3]
				},
			},
			{
				path:"/pfxz2",
				name:"评分细则",
				component: () => import('@/pages/dwgl/nzkh/yxdwgzz/pfxz'),
				meta:{
					isMenu:false,
					requiresAuth:[1,2,3]
				}
			},
		]
	},
	{
		path:"/dftz",
		name:"台账经费",
		component: () => import('@/pages/dwgl/dftz'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:"/gztz",
		name:"工作台账",
		component: () => import('@/pages/dwgl/gztz'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:"/zztz",
		name:"党员统计",
		component: () => import('@/pages/dwgl/zztz'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	}
]

// 党建宣传
export const djxcRoutes = [
	{
		path:'/djxc_ywzx',
		name:"党建要闻",
		component:() => import('@/pages/djxc/djxc_ywzx'),
		meta:{
			isMenu:true,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:"/ywzx_add",
		name:"新增要闻",
		component: () => import('@/pages/djxc/djxc_ywzx/ywzx_add.vue'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:"/ywzx_detail",
		name:"党建要闻详情",
		component: () => import('@/pages/djxc/djxc_ywzx/ywzx_detail.vue'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:'/djxc_fczs',
		name:"风采展示",
		component:() => import('@/pages/djxc/djxc_fczs'),
		meta:{
			isMenu:true,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:"/fczs_add",
		name:"新增风采展示",
		component: () => import('@/pages/djxc/djxc_fczs/fczs_add'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:"/fczs_detail",
		name:"风采展示详情",
		component: () => import('@/pages/djxc/djxc_fczs/fczs_detail.vue'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:'/djxc_xccl',
		name:"宣传材料",
		component:() => import('@/pages/djxc/djxc_xccl'),
		meta:{
			isMenu:true,
			requiresAuth:[1,2,3]
		}
	},
	// {
	// 	path:'/djxc_hyhb',
	// 	name:"欢迎海报",
	// 	component:() => import('@/pages/djxc/djxc_hyhb'),
	// 	meta:{
	// 		isMenu:true,
	// 		requiresAuth:[1,2,3]
	// 	}
	// },
	
]

// 党建共建
export const dqgjRoutes = [
	{
		path:'/djdd',
		name:"党建带动",
		component:() => import('@/pages/dqgj/djdd'),
		meta:{
			isMenu:true,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:"/djdd_detail",
		name:"党建带动详情",
		component: () => import('@/pages/dqgj/djdd/djdd_detail'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:"/djdd_add",
		name:"新增党建带动",
		component: () => import('@/pages/dqgj/djdd/djdd_add'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:'/fwhz',
		name:"服务互助",
		component:() => import('@/pages/dqgj/fwhz'),
		meta:{
			isMenu:true,
			requiresAuth:[1,2,3]
		}
	},
	
	{
		path:"/fwhz_detail",
		name:"服务互助详情",
		component: () => import('@/pages/dqgj/fwhz/fwhz_detail'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:"/fwhz_add",
		name:"新增服务互助",
		component: () => import('@/pages/dqgj/fwhz/fwhz_add'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:'/ywfz',
		name:"业务发展",
		component:() => import('@/pages/dqgj/ywfz'),
		meta:{
			isMenu:true,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:"/ywfz_detail",
		name:"业务发展详情",
		component: () => import('@/pages/dqgj/ywfz/ywfz_detail'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:"/ywfz_add",
		name:"新增业务发展",
		component: () => import('@/pages/dqgj/ywfz/ywfz_add'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:'/sjxx',
		name:"书记信箱",
		component:() => import('@/pages/dqgj/sjxx'),
		meta:{
			isMenu:true,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:"/sjxx_detail",
		name:"书记信箱详情",
		component: () => import('@/pages/dqgj/sjxx/sjxx_detail'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:'/zfjs',
		name:"作风建设",
		component:() => import('@/pages/dqgj/zfjs'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3],
			dwid:804
		}
	},
	{
		path:"/zfjs_detail",
		name:"作风建设详情",
		component: () => import('@/pages/dqgj/zfjs/zfjs_detail'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:"/zfjs_add",
		name:"新增作风建设",
		component: () => import('@/pages/dqgj/zfjs/zfjs_add'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:'/ysxt',
		name:"意识形态",
		component:() => import('@/pages/dqgj/ysxt'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3],
			dwid:804
		}
	},
	{
		path:"/ysxt_detail",
		name:"意识形态详情",
		component: () => import('@/pages/dqgj/ysxt/ysxt_detail'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:"/ysxt_add",
		name:"新增意识形态",
		component: () => import('@/pages/dqgj/ysxt/ysxt_add'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
]

// 系统设置
export const xtszRoutes = [
	{
		path:'/xtsz_dlrz',
		name:"登录日志",
		component:() => import('@/pages/xtsz/xtsz_dlrz'),
		meta:{
			isMenu:true,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:'/zhgl',
		name:"账号管理",
		component: {render(c){return c('router-view')}},
		meta:{
			isMenu:true,
			requiresAuth:[1,2]
		},
		children:[
			{
				path:'/xtsz_dzzzhgl',
				name:"党组织账号管理",
				component:() => import('@/pages/xtsz/zhgl/xtsz_dzzzhgl'),
				meta:{
					isMenu:true,
					requiresAuth:[1,2]
				}
			},
			{
				path:'/xtsz_dyzhgl',
				name:"党员账号管理",
				component:() => import('@/pages/xtsz/zhgl/xtsz_dyzhgl'),
				meta:{
					isMenu:true,
					requiresAuth:[1,2,3]
				}
			},
		]
	},
	{
		path:'/xtsz_dyzhgl',
		name:"党员账号管理",
		component:() => import('@/pages/xtsz/zhgl/xtsz_dyzhgl'),
		meta:{
			isMenu:true,
			requiresAuth:[3]
		}
	},
	{
		path:'/xtsz_xgmm',
		name:"账户设置",
		component:() => import('@/pages/xtsz/xtsz_xgmm'),
		meta:{
			isMenu:true,
			requiresAuth:[1,2,3]
		}
	},
	{
		path:'/message',
		name:"消息",
		component:() => import('@/pages/message/index.vue'),
		meta:{
			isMenu:false,
			requiresAuth:[1,2,3]
		}
	},
]
// 消息设置
export const messRoutes = [
	{
		path:'/message',
		name:"message",
		component:() => import('@/pages/message/index.vue'),
		meta:{
			isMenu:true,
			requiresAuth:[1,2,3]
		}
	},
	
]